import { DictionaryHydrogeologicalZoneAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionaryHydrogeologicalZones() {
  return useAutocompleteSource<DictionaryHydrogeologicalZoneAutocomplete>({
    url: EvidenceAPI.DICTIONARY_HYDROGEOLOGICAL_ZONES + '/autocomplete',
  });
}
